// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3DpbZ","options":"AnswerScale_options__31zj9","selected":"AnswerScale_selected__1hQ3h"};